import {createSvgIcon} from "@mui/material";

export const DzenIcon2 = createSvgIcon(
    <>
        <path d="M0 9C0 4.02943 4.02943 0 9 0C13.9706 0 18 4.02943 18 9C18 13.9706 13.9706 18 9 18C4.02943 18 0 13.9706 0 9Z" fill="#ffffff"/>
        <path d="M8.81788 0C8.77535 3.70266 8.53322 5.77485 7.15404 7.15404C5.77485 8.53322 3.70266 8.77535 0 8.81788V9.35521C3.70266 9.3977 5.77485 9.63984 7.15404 11.019C8.51159 12.3766 8.76748 14.4056 8.81573 18H9.35736C9.40558 14.4056 9.66147 12.3766 11.019 11.019C12.3766 9.66147 14.4056 9.40558 18 9.35736V8.81569C14.4056 8.76748 12.3766 8.51159 11.019 7.15404C9.63984 5.77485 9.3977 3.70266 9.35521 0H8.81788Z" fill="#006655" fillRule="evenodd" clipRule="evenodd"/>
    </>,
    'Dzen2'
);